//
// Copyright 2020 DXOS.org
//

import { lazy } from 'react';

export const CredentialsArticle = lazy(() => import('./CredentialsArticle/index.ts'));
export const DeviceListArticle = lazy(() => import('./DeviceListArticle/index.ts'));
export const IdentityArticle = lazy(() => import('./IdentityArticle/index.ts'));
export const KeyringArticle = lazy(() => import('./KeyringArticle/index.ts'));
